export const INSPECTION_DISABLE = "INSPECTION DISABLE";
